<template>
  <div class="performanceData" v-loading="loading">
    <div class="header">
      <div class="header_left">
        <el-radio-group v-model="type" @input="typeChange">
          <el-radio-button class="header_left_radio" label="1">门诊</el-radio-button>
          <el-radio-button class="header_left_radio" label="2">网诊</el-radio-button>
        </el-radio-group>
      </div>
      <div class="header_right">
        <DateSelect v-model="date" @change="dateChange"></DateSelect>
      </div>
    </div>

    <!-- <div class="card registration">
      <div class="card_header">
        <div class="card_header_left">
          <div class="card_header_title">
            <el-popover
              placement="top-start"
              popper-class="tips_popover"
              width="295"
              trigger="click">
              <div>
                <div>统计日期内挂号费含券合计金额（支付合计-退费合计）</div>
              </div>
              <span slot="reference" class="el-icon-question" style="margin: 0 4px 0 0; color: #9aa3ad;"></span>
            </el-popover>
            <span>挂号费金额展示</span>
          </div>
          <div class="card_header_date">{{ date | dateFilter }}</div>
        </div>
      </div>
      <div class="registration_dept_list">
        <div v-for="registrationDept in registrationDeptList" :key="registrationDept.deptId" :class="{ registration_dept_item: true, active: registrationDept.deptId == registrationDeptActive }" @click="registrationDeptOn(registrationDept.deptId)">
          <div class="registration_dept_title">{{ registrationDept.deptName }} | 挂号费(元)</div>
          <div class="registration_dept_count">{{ registrationDept.totalAmount }}</div>
        </div>
      </div> -->
      <!-- <div class="registration_info" v-if="type === '1'">
        <table class="performance_table" :style="`--td-num: ${ type === '1' ? 2 : 0 };`">
          <tr class="performance_tr">
            <td class="performance_td">
              <div class="performance_type">{{ type === '1' ? '门诊' : '网诊' }}</div>
            </td>
            <td v-if="type === '1'" class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">已诊(元)</div>
                <div class="performance_td_value">{{ registrationInfo && registrationInfo.alreadySeeAmount }}</div>
              </div>
            </td>
            <td v-if="type === '1'" class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">转方(元)</div>
                <div class="performance_td_value">{{ registrationInfo && registrationInfo.transferAmount }}</div>
              </div>
            </td>
          </tr>
        </table>
      </div> -->
    <!-- </div> -->

    <div class="card sales">
      <div class="card_header">
        <div class="card_header_left">
          <div class="card_header_title">销售额展示</div>
          <div class="card_header_date">{{ date | dateFilter }}</div>
        </div>
      </div>
      <div class="sales_dept_list">
        <div v-for="salesDept in salesDeptList" :key="salesDept.deptId" :class="{ sales_dept_item: true, active: salesDept.deptId == salesDeptActive }" @click="salesDeptOn(salesDept.deptId)">
          <div class="sales_dept_title">{{ salesDept.deptName }} | 销售额(元)</div>
          <div class="sales_dept_count">{{ salesDept.totalPayAmount }}</div>
        </div>
      </div>
      <div class="sales_info">
        <table class="performance_table">
          <tr class="performance_tr">
            <td class="performance_td">
              <div class="performance_type">中药</div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">饮片-普通(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.piecePay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">饮片-医联(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.pieceYlPay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">颗粒-普通(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.particlePay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">颗粒-医联(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.particleYlPay }}</div>
              </div>
            </td>
            <td class="performance_td"></td>
          </tr>
          <tr class="performance_tr">
            <td class="performance_td">
              <div class="performance_type">中成药</div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">中成药(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.chinesePatentDrugPay }}</div>
              </div>
            </td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
          </tr>
          <tr class="performance_tr">
            <td class="performance_td">
              <div class="performance_type">理疗</div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">理疗项目(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.physioPay }}</div>
              </div>
            </td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
          </tr>
          <tr class="performance_tr">
            <td class="performance_td" rowspan="3">
              <div class="performance_type" style="--rowspan: 3;">其他</div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">加工费-熬药(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.decoctHerbsPay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">加工费-制膏(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.creamMakingPay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">加工费-制丸(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.pillPay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">加工费-打粉(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.powderPay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">加工费-YL(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.comboPay }}</div>
              </div>
            </td>
          </tr>
          <tr class="performance_tr">
            <td class="performance_td"></td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">快递费(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.deliveryPricePay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">医疗器械(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.medicalDevicePay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">后勤材料(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.logisticsMaterialPay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">保健食品(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.healthFoodPay }}</div>
              </div>
            </td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">其他商品(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.otherGoodsPay }}</div>
              </div>
            </td>
          </tr>
          <tr class="performance_tr">
            <td class="performance_td"></td>
            <td class="performance_td">
              <div class="performance_td_item">
                <div class="performance_td_label">未分类(元)</div>
                <div class="performance_td_value">{{ salesInfo && salesInfo.notClassifiedPay }}</div>
              </div>
            </td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
            <td class="performance_td"></td>
          </tr>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    getOutpatientRegistrationStatistics,
    getOnlineRegistrationStatistics,
    getDoctorSalesStatistics
  } from "@/api/doctorDataAnalysis"

  import DateSelect from './components/DateSelect.vue'

  export default {
    name: 'performanceData',
    components: { DateSelect },
    filters: {
      dateFilter (value) {
        if (Array.isArray(value) && value.length === 2) {
          if (value[0] === value[1]) {
            const today = new Date().Format('yyyy-MM-dd')
            if (value[0] === today) {
              return `今天${new Date(today).Format('MM.dd')}`
            }

            let tomorrowDay = new Date()
            tomorrowDay.setDate(tomorrowDay.getDate() + 1)
            tomorrowDay = tomorrowDay.Format('yyyy-MM-dd')
            if (value[0] === tomorrowDay) {
              return `明天${new Date(tomorrowDay).Format('MM.dd')}`
            }

            let afterTomorrow = new Date()
            afterTomorrow.setDate(afterTomorrow.getDate() + 2)
            afterTomorrow = afterTomorrow.Format('yyyy-MM-dd')
            if (value[0] === afterTomorrow) {
              return `后天${new Date(afterTomorrow).Format('MM.dd')}`
            }

            let yesterdayDay = new Date()
            yesterdayDay.setDate(yesterdayDay.getDate() - 1)
            yesterdayDay = yesterdayDay.Format('yyyy-MM-dd')
            if (value[0] === yesterdayDay) {
              return `昨天${new Date(yesterdayDay).Format('MM.dd')}`
            }

            let format = new Date(value[0]).Format('yyyy') === new Date().Format('yyyy') ? 'MM.dd' : 'yyyy.MM.dd'
            return `${new Date(value[0]).Format(format)}`
          } else {
            return `${new Date(value[0]).Format('yyyy.MM.dd')} - ${new Date(value[1]).Format('yyyy.MM.dd')}`
          }
        }
        return ''
      }
    },
    props: {
      doctorId: {
        type: [Number, String],
        default: ''
      }
    },
    data () {
      return {
        loading: false,
        reqNum: 0,
        type: '1',
        date: [new Date().Format('yyyy-MM-dd'), new Date().Format('yyyy-MM-dd')],
        registrationDeptActive: 0,
        registrationDeptList: [],
        salesDeptActive: 0,
        salesDeptList: []
      }
    },
    computed: {
      registrationInfo () {
        return this.registrationDeptList.find(item => item.deptId === this.registrationDeptActive)
      },
      salesInfo () {
        return this.salesDeptList.find(item => item.deptId === this.salesDeptActive)
      }
    },
    created () {
      this.getRegistrationList()
      this.getSalesList()
    },
    methods: {
      afterRes () {
        this.reqNum--;
        if (this.reqNum <= 0) {
          this.loading = false
          this.reqNum = 0;
        }
      },
      async getRegistrationList () {
        let res = null
        this.loading = true
        this.reqNum++
        if (this.type === '1') {
          res = await getOutpatientRegistrationStatistics({
            doctorId: this.doctorId,
            startDate: this.date[0],
            endDate: this.date[1]
          })
        } else {
          res = await getOnlineRegistrationStatistics({
            doctorId: this.doctorId,
            startDate: this.date[0],
            endDate: this.date[1]
          })
        }

        this.afterRes()

        if (res.code === 200) {
          this.registrationDeptList = res.data && res.data.sort((a, b) => { return a.deptId - b.deptId }) || []
          if (res.data && res.data.length > 0) {
            this.registrationDeptActive = this.registrationDeptList[0].deptId
          }
        }
      },
      async getSalesList () {
        this.loading = true
        this.reqNum++
        const res = await getDoctorSalesStatistics({
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
          type: this.type
        })
        this.afterRes()
        if (res.code === 200) {
          this.salesDeptList = res.data && res.data.sort((a, b) => { return a.deptId - b.deptId }) || []
          if (res.data && res.data.length > 0) {
            this.salesDeptActive = this.salesDeptList[0].deptId
          }
        }
      },
      typeChange () {
        this.getRegistrationList()
        this.getSalesList()
      },
      dateChange () {
        this.getRegistrationList()
        this.getSalesList()
      },
      registrationDeptOn (deptId) {
        if (![null, undefined].includes(deptId) && this.registrationDeptActive !== deptId) {
          this.registrationDeptActive = deptId
        }
      },
      salesDeptOn (deptId) {
        if (![null, undefined].includes(deptId) && this.salesDeptActive !== deptId) {
          this.salesDeptActive = deptId
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .performanceData {
    width: 100%;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_left_radio /deep/ .el-radio-button__inner {
    padding: 0 28px;
    height: 36px;
    line-height: 34px;
  }

  .card {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
  }

  .card_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .card_header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .card_header_icon {
    width: 26px;
    height: 26px;
  }

  .card_header_title {
    line-height: 28px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }

  .card_header_icon+.card_header_title {
    margin: 0 0 0 10px;
  }

  .card_header_date {
    margin: 0 0 0 8px;
    line-height: 22px;
    font-size: 14px;
    color: #667182;
  }

  .card_header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .card_header_count {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }

  .to_more {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
  }

  .to_more_text {
    font-size: 14px;
    color: #667182;
  }

  .to_more_icon {
    margin: 0 0 0 2px;
    font-size: 14px;
    color: #667182;
  }

  .registration {
    margin: 24px 0 0 0;
  }

  .registration_dept_list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 16px -16px -16px 0;
    width: calc(100% + 16px);
  }

  .registration_dept_item {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    margin: 0 16px 16px 0;
    padding: 24px;
    width: 275px;
    height: 110px;
    background-color: #E8F4FF;
    border-radius: 8px;
    cursor: pointer;
  }

  .registration_dept_item.active {
    background: linear-gradient( 135deg, #39A0FF 0%, #0177E5 100%);
    box-shadow: 0px 2px 8px 0px rgba(0,29,57,0.2);
  }

  .registration_dept_item.active::after {
    content: '\25BC';
    position: absolute;
    z-index: 1;
    bottom: -10px;
    left: 50%;
    font-size: 12px;
    color: #1283ED;
    transform: translate(-50%, 0);
  }

  .registration_dept_title {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }

  .registration_dept_item.active .registration_dept_title {
    color: #FFFFFF;
  }

  .registration_dept_count {
    margin: 4px 0 0 0;
    line-height: 36px;
    font-weight: bold;
    font-size: 22px;
    color: #000000;
  }

  .registration_dept_item.active .registration_dept_count {
    color: #FFFFFF;
  }

  .registration_info {
    margin: 24px 0 0 0;
    width: 100%;
  }

  .sales {
    margin: 16px 0 0 0;
  }

  .sales_dept_list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 16px -16px -16px 0;
    width: calc(100% + 16px);
  }

  .sales_dept_item {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    margin: 0 16px 16px 0;
    padding: 24px;
    width: 275px;
    height: 110px;
    background-color: #EBEAFF;
    border-radius: 8px;
    cursor: pointer;
  }

  .sales_dept_item.active {
    background: linear-gradient( 143deg, #8E87FF 0%, #765FFF 100%);
    box-shadow: 0px 2px 8px 0px rgba(0,50,54,0.2);
  }

  .sales_dept_item.active::after {
    content: '\25BC';
    position: absolute;
    z-index: 1;
    bottom: -10px;
    left: 50%;
    font-size: 12px;
    color: #7E6CFF;
    transform: translate(-50%, 0);
  }

  .sales_dept_title {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }

  .sales_dept_item.active .sales_dept_title {
    color: #FFFFFF;
  }

  .sales_dept_count {
    margin: 4px 0 0 0;
    line-height: 36px;
    font-weight: bold;
    font-size: 22px;
    color: #000000;
  }

  .sales_dept_item.active .sales_dept_count {
    color: #FFFFFF;
  }

  .sales_info {
    margin: 24px 0 0 0;
    width: 100%;
  }

  .performance_table {
    --td-num: 5;
    width: calc((100% - 60px) / 5 * var(--td-num) + 60px);
    background-color: #F7F8F9;
    border-collapse: separate;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
  }

  .performance_tr {
    display: grid;
    grid-template-columns: 60px repeat(var(--td-num), 1fr);
  }

  .performance_tr+.performance_tr {
    border-top: 1px solid #E0E0E0;
  }

  .performance_td {
    box-sizing: border-box;
    height: 52px;
  }

  .performance_td+.performance_td {
    border-left: 1px solid #E0E0E0;
  }

  .performance_type {
    --rowspan: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: calc(100% * var(--rowspan));
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    background-color: #F7F8F9;
  }

  .performance_td_item {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    height: 100%;
  }

  .performance_td_label {
    font-weight: 500;
    font-size: 14px;
    color: #667182;
  }

  .performance_td_value {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }
</style>